/*
 * Locale basics shared by i18n, formatting and the shell. Arabic is the default (RTL); English is the
 * counterpart (LTR). Digits are always Latin and the calendar always Gregorian, in both languages.
 */
export type Locale = 'ar' | 'en'
export const LOCALES: readonly Locale[] = ['ar', 'en']
export const DEFAULT_LOCALE: Locale = 'ar'
export const LOCALE_STORAGE_KEY = 'bpanel.locale'

export function dirOf(locale: Locale): 'rtl' | 'ltr' {
  return locale === 'ar' ? 'rtl' : 'ltr'
}

/** BCP 47 tag for Intl: Latin digits and the Gregorian calendar in Arabic. */
export function intlLocale(locale: Locale): string {
  return locale === 'ar' ? 'ar-SA-u-nu-latn-ca-gregory' : 'en-GB'
}

export function isLocale(v: unknown): v is Locale {
  return v === 'ar' || v === 'en'
}
